// btw-front/src/constants/dealStatus.js
// 영업단계 7개 — 백 `btw-back/constants/dealStatus.js` 와 동기.
// 페이지 컴포넌트(대시보드·실적·딜 상세 등) 에서 import.

export const SALES_STAGES = [
  "brochure_sent",
  "intro",
  "prelim_quote",
  "poc",
  "proposal",
  "adoption",
  "lost",
];
export const SALES_STAGE_DEFAULT = "brochure_sent";
// 대시보드 KPI 집계용: 진행중(소개서~제안 5단계 합)
export const IN_PROGRESS_STAGES = ["brochure_sent", "intro", "prelim_quote", "poc", "proposal"];
